<template>
  <div no-body class="">
    asdsadasdasdsad<br />
    asdsadasdasdsad<br />
    asdjgsadhgsajd<br />
    asdjgsadhgsajd<br />
    asjdsagdjg
  </div>
</template>

<script>
import { BCard } from "bootstrap-vue";
export default {
  components: {
    BCard,
  },
  props: {
    config: { default: {} },
    layoutData: { default: {} },
    data: { default: {} },
  },
  setup(props) {
    console.log(props.data);

    return {};
  },
};
</script>

<style scoped></style>
